export default "__VITE_ASSET__0mY6gM6G__"